document.addEventListener('DOMContentLoaded', function () {
  const bars = document.querySelectorAll('.progress-bar_fill');

  const animateBar = (bar) => {
    const percent = bar.getAttribute('data-progress');
    if (!percent) return;

    // Reset the bar to 0% width
    bar.style.transition = 'none';
    bar.style.width = '0%';
    void bar.offsetWidth; // Force reflow

    // Apply slower, more elegant animation
    bar.style.transition = 'width 4s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    bar.style.width = percent + '%';

    // Start donation counter animation at the same time
    animateDonationAmount();

    // Add a subtle pulse effect when animation completes
    setTimeout(() => {
      bar.style.boxShadow = '0 0 10px rgba(244, 162, 97, 0.4)';
      setTimeout(() => {
        bar.style.boxShadow = '';
      }, 300);
    }, 4000);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add a small delay for more elegant entrance
          setTimeout(() => {
            animateBar(entry.target);
          }, 200);
        }
      });
    },
    {
      threshold: 0.3, // Trigger animation a bit earlier
      rootMargin: '0px 0px -50px 0px' // Start animation before element is fully visible
    }
  );

  bars.forEach((bar) => observer.observe(bar));

  // Function to animate donation amount counter
  const animateDonationAmount = () => {
    const donationEl = document.querySelector('.donation-amount');
    if (!donationEl) return;

    const rawValue = parseFloat(donationEl.dataset.amount);
    if (isNaN(rawValue)) return;

    // Reset counter to 0
    let currentValue = 0;
    donationEl.textContent = '0';

    // Animate the number counting up - same duration as progress bar
    const increment = rawValue / 120; // 120 steps for smooth animation
    const duration = 4000; // 4 seconds - same as progress bar
    const stepTime = duration / 120;

    const countUp = () => {
      currentValue += increment;
      if (currentValue >= rawValue) {
        currentValue = rawValue;
        const formatted = rawValue.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
        donationEl.textContent = formatted;
        return;
      }

      const formatted = Math.floor(currentValue).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      donationEl.textContent = formatted;
      setTimeout(countUp, stepTime);
    };

    // Start counting immediately when called
    countUp();
  };
});
